<template>
  <div>
    
   <!-- Navbar Links -->
    <div class="navbar-container">
      <div class="navbar-backdrop"></div>
      <div class="navbar-content">
        <nav>
          <div class="container-fluid">
            <div class="navbar">
              <div class="nav-logo">
                <router-link :to="{ name: 'home' }">
                  <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')"  class="img-fluid" alt="Logo" /> 
                  <span class="ml-2" v-html="logo.title ? logo.title : 'ASPE'"></span>
                </router-link>
              </div>
              <button id="closeNavbar" @click="closeMenu()" class="close-navbar d-flex align-items-center white-color"><span class="icon-cancel mr-3"></span> <span class="cm-text">Close Menu</span></button>
            </div>
          </div>
        </nav>

        <!-- <div class="navbar-header d-flex justify-content-between align-items-center">
          <div class="nav-logo">
            <router-link :to="{ name: 'home' }"><img src="../assets/logo.png" class="img-fluid" alt="Logo" />  <span class="ml-2">ASPE</span></router-link>
          </div>
          <button id="closeNavbar" @click="closeMenu()" class="close-navbar d-flex align-items-center white-color"><span class="icon-cancel mr-3"></span> <span class="cm-text">Close Menu</span></button>
        </div> -->

        <div class="navbar-body">
          <div class="navbar-body-content container-fluid d-flex justify-content-between">
              <div class="nb-links">
                <div>
                    <router-link v-if="(header[0]) ? header[0].status : false" 
                        to="/accreditations" class="nv-link">Accreditation</router-link>
                </div>
                <div>
                    <router-link v-if="(header[1]) ? header[1].status : false" 
                        to="/programs" class="nv-link">Programs</router-link>
                </div>
                <div>
                    <router-link v-if="(header[2]) ? header[2].status : false" 
                        to="/memberships" class="nv-link">Membership</router-link>
                </div>
                <div>
                    <router-link v-if="(header[3]) ? header[3].status : false" 
                        to="/about" class="nv-link">About</router-link>
                </div>
                <div>
                    <router-link v-if="(header[4]) ? header[4].status : false" 
                        to="/contact" class="nv-link">Contact Us</router-link>
                </div>
                <div>
                    <router-link v-if="(header[5]) ? header[5].status : false" 
                        to="/our-certificates" class="nv-link">Certification</router-link>
                </div>
                <div>
                    <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                              :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                        class="nv-link"
                        :class="(pg.has_header) ? '' : 'hidden' ">
                        {{ pg.title }}
                    </router-link>
                </div>
              </div>

              <div class="nb-top-links">
                <div class="nb-border-left">
                  <div class="sm-title mb-3 white-color">Top Links</div>
                  <div class="top-links">
                    <a href="javascript:;" 
                      @click="opnPopular(nav.slug)" class="tp-links"  v-for="(nav, index) in popularSearch" :key="index">
                      {{ nav.title }}
                    </a>
                  </div>
                  <div class="nb-view mt-5">
                    <img :src="logo.top_links ? logo.top_links : require('../assets/img/home.png')" class="img-fluid" alt="" />
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="navbar-footer">
          <div class="white-color container-fluid">
            2021 All Rights Reserved  © ASPE American Society of Professional Engineers   
            <router-link class="nf-link white-color"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy"> Privacy Policy
            </router-link>
            
          </div>
        </div>
      </div>
    </div>
    <!-- Navbar Links -->

    <!-- Navbar -->
    <nav id="navigationBar"> <!-- v-bind:class="{'activeSearch': toggleSearch}" -->
      <div class="container-fluid">
        <div class="navbar">
          <div class="nav-logo">
            <router-link :to="{ name: 'home' }">
              <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')" class="img-fluid" alt="Logo" /> 
              <span class="ml-2" v-html="logo.title ? logo.title : 'ASPE'"></span>
            </router-link>
          </div>
          <div class="nav-btns d-flex align-items-center">
            <div class="us mr-3 d-flex align-items-center dropdown">

              <button v-if="authenticated"
                type="button"
                name="button"
                class="navbar-action"
                data-toggle="dropdown">
              <div class="showDropdown">
                  <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                      alt="" 
                      class="img-fluid" 
                      style="width:38px;height:38px;border-radius: 50%;">
                  <div class="dropdown-menu">
                    <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                    <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                  </div>
              </div>
            </button>

              <router-link v-if="!authenticated" to="/login">
                <button type="button" class="d-flex align-items-center">
                  <span class="icon-user"></span>
                </button>
              </router-link>


              <span class="ml-3 mr-3 white-color">|</span>

              <button @click="toggleSearch = !toggleSearch" type="button" class="d-flex align-items-center">
                  <span v-if="!toggleSearch" class="icon-search"></span>
                  <span v-else class="icon-cancel"></span>
              </button>

            </div>
            <div id="menuBtn" class="menu-btn"  @click="openMenu()">
              <span class="top-bar"></span>
              <span class="middle-bar"></span>
              <span class="bottom-bar"></span>
              <div class="menu-text">Menu</div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- Navbar -->
  <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped="">
.hidden { display: none !important }
.dropdown-menu {
  left: auto;
  right: 0;
}
.navbar-container nav {
  background: none;
  position: relative;
}
</style>

<script>
import axios from "axios";
import SearchPopup from './SearchPopup';
export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      popularSearch: [],
      avatar: '',
      authenticated: false,
      searchPage: false,
      toggleSearch: false
    };
  },
  created() {

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }

    this.fetchPopularSearchs();
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  mounted() {
    if ($(window).scrollTop() > 0) {
        $('#navigationBar').addClass('active');
    } 
    
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('#navigationBar').addClass('active');
        } else {
            $('#navigationBar').removeClass('active');
        }
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },

    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          const data = res.data;
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
          console.log(data);
        })
        .catch(() => {});
    },

    fetchPopularSearchs: function () {
      axios
        .get(window.baseURL + "/popularSearch")
        .then((res) => {
          var data = res;
          this.popularSearch = res.data.rows;
          console.log(res.data.rows);
        })
        .catch(() => { });
    },


    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

    openMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.add('active');
        el2.classList.add('active');
    },

    closeMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.remove('active');
        el2.classList.remove('active');
    }

  }
};
</script>
